import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import "../styles/style_404.css";
import goldenFlower from "../assets/pictures/logo/logoLatelierFloral.png";

export default function NotFound() {
  const petals = Array.from({ length: 14 });
  const { user, loading } = useAuth();

  return (
    <main className="nf">
      <div className="nf__petals" aria-hidden="true">
        {petals.map((_, index) => (<span key={index} className={`nf__petal nf__petal-${(index % 7) + 1}`} />))}
      </div>

      <section className="nf__card">
        <div className="nf__halo" aria-hidden="true" />
        <img src={goldenFlower} alt="Illustration bouquet" className="nf__flower" loading="lazy" />
        <p className="nf__eyebrow">Oups... jardin vide</p>
        <h1>404 - Page introuvable</h1>
        <p className="nf__text">
          La page que vous cherchez semble s'etre eclipsee. Continuez votre
          balade parmi nos bouquets et creations.
        </p>
        <div className="nf__actions">
          <Link className="nf__btn nf__btn-main" to="/">Retour a l'accueil</Link>
          { !user && (<Link className="nf__btn nf__btn-ghost" to="/auth">Se connecter</Link>)}
        </div>
      </section>
    </main>
  );
}
